import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserModuleSuggestionOutput } from 'infrastructure/graphql/content/user/model/user-module-suggestion.output';

import { ApiQuery } from '../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchUserModuleSuggestionsApiQuery extends ApiQuery<
	UserModuleSuggestionOutput[],
	void
> {
	client = 'content';
	document = gql`
		query FetchUserModuleSuggestions {
			fetchUserModuleSuggestions {
				organizationModule {
					id
				}
				priority
				user {
					id
				}
			}
		}
	`;
	method = 'fetchUserModuleSuggestions';
}
